var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowrightNoFill = function SvgArrowrightNoFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.564 14.93 5.594 8 .564 1.07 1.357 0 9 7.09v1.82L1.357 16z"
  })));
};
export default SvgArrowrightNoFill;